import { useMediaQuery } from '@mui/material';
export { useMediaQuery };
export const useIsMobile = () => useMediaQuery((theme) => theme.breakpoints.down('sm'));
export const useIsDesktop = () => useMediaQuery((theme) => theme.breakpoints.up('md')); // todo lg instead of md
export const useIsTablet = () => useMediaQuery((theme) => theme.breakpoints.between('sm', 'md')); // TODO what is the use case? why overlap ('sm', 'lg')
